import { render, staticRenderFns } from "./FormCreateMetaDataCategory.vue?vue&type=template&id=1d4200b8&"
import script from "./FormCreateMetaDataCategory.vue?vue&type=script&lang=js&"
export * from "./FormCreateMetaDataCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports